<ridango-block-full-width role="radiogroup" role="radiogroup" aria-labelledby="product_title">
    <h2 class="block-full-width__title" id="product_title">{{ 'ADDITIONAL_INFORMATION_TITLE' | translate }}</h2>

    <form [formGroup]="_additionalForm" ridangoFocusInvalidInput>
        <ridango-form-field class="form-margin-10">
            <textarea
                class="dark:bg-black"
                [formControl]="_additionalForm.controls.additional_information"
                (change)="change()"
                rows="7"
                ridangoInput
                ridangoUntouchOnFocusout
                name="additional_information"></textarea>
        </ridango-form-field>
    </form>
</ridango-block-full-width>
